"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var mobx_react_1 = require("mobx-react");
var owa_get_started_1 = require("owa-get-started");
var owa_getstarted_strings_1 = require("owa-strings/owa-getstarted-strings");
var owa_analytics_1 = require("owa-analytics");
var GetStartedPane = /** @class */ (function (_super) {
    tslib_1.__extends(GetStartedPane, _super);
    function GetStartedPane(props) {
        return _super.call(this, props) || this;
    }
    GetStartedPane.prototype.render = function () {
        var _this = this;
        owa_analytics_1.logUsage('getStartedPaneOpened');
        return (React.createElement(HeaderFlexPane_1.default, { title: owa_getstarted_strings_1.default.getStarted_FlexPane_Title, content: React.createElement(owa_get_started_1.GetStartedTaskContainer, null), onDismiss: function () {
                _this.props.onDismiss();
            } }));
    };
    GetStartedPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], GetStartedPane);
    return GetStartedPane;
}(React.Component));
exports.default = GetStartedPane;
//# sourceMappingURL=GetStartedPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/GetStartedPane.js
// module id = 6231
// module chunks = 38